'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--StarOutlined';

var EntypoStarOutlined = function EntypoStarOutlined(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M18.8,8.022h-6.413L10,1.3L7.611,8.022H1.199l5.232,3.947L4.56,18.898L10,14.744l5.438,4.154l-1.869-6.929L18.8,8.022z M10,12.783l-3.014,2.5l1.243-3.562l-2.851-2.3L8.9,9.522l1.1-4.04l1.099,4.04l3.521-0.101l-2.851,2.3l1.243,3.562L10,12.783z' })
    );
};

exports.default = EntypoStarOutlined;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-entypo-icons/lib/entypo/StarOutlined.js
// module id = 769
// module chunks = 168707334958949